import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ResetPassword from './ResetPassword';

function RedirectExternal() {
  window.location.replace('https://turkcedunyasi.com');
  return null;
}

export default function App() {
  return (
    <Routes>
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="*" element={<RedirectExternal />} />
    </Routes>
  );
}
